module.exports = __webpack_public_path__ + "img/bunny-ears-2.12bfc11b.svg";